import { setState } from '../../storage'
import * as types from '../mutation-types'

const shouldSkipCache = (mutationType) => {
  // console.log('cache - should skip?', mutation)
  if (mutationType === types.LOAD_FROM_CACHE ||
      mutationType === types.NM_ONLINE ||
      mutationType === types.NM_OFFLINE ||
      mutationType === types.NM_SERVER_ONLINE ||
      mutationType === types.NM_SERVER_OFFLINE) {
    return true
  }
  return false
};

const plugin = (store) => {
  store.subscribe((mutation, state) => {
    // if store not initialized (ie. loaded from cache), do not setState with empty store?
    if (!shouldSkipCache(mutation.type)) {
      console.log(`cache (plugin) triggered by mutation ${mutation.type}`, state)
      setState(state).catch(err => console.warn('failed to cache state', err));
    }
  });
};

export default plugin;